<template>
    <div class="user-autocomplete form-group autocomplete" :class="theClasses">
        <label v-if="!!label" :for="id">{{ label }} <span v-if="!!required" class="field-required-mark">*</span></label>
        <input 
            type="text" 
            :id="id" 
            autocomplete="off" 
            class="form-control" 
            v-model="search"
            @input="startSearching"
            @keyup.up="moveUp"
            @keyup.down="moveDown"
            @keyup.enter="enter"
            @blur="delayClear"
            @change="$emit('change', $event.target.value)"
        />
                <span class="field-error" v-if="hasError">{{ errorMessage }}</span>
        <ul class="autocomplete__results" v-if="results.length > 0 && !!showResults">
            <li v-for="(item, idx) in results" class="autocomplete__results--result" :key="idx" :class="{ 'autocomplete-result-selected': idx === index }" @click="setItem(idx)">{{ item.name }}</li>
        </ul>
    </div>
</template>
<script>

    import autocompleteRepository from '../../../../repositories/autocomplete.repository';

    export default {
        props: {
            type: {
                type: String,
                validator: val => {
                    return [
                        'people',
                        'people_structures',
                        'structures',
                        'users'
                    ].includes(val);
                }
            },
            label: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: () => {
                    return `autocomplete-${parseInt(Math.random()*100)}`;
                }
            },
            required: {
                default: ''
            },
            value: {
                default: ''
            },
            exists: {
                default: false
            },
            hasError: {
                type: Boolean,
                default: false
            },
            errorMessage: {
                type: String,
                default: ''
            },
            selectOnFocus: {
                type: Boolean,
                default: true
            },
            classes: {},
            clientId: {
                default: ''
            }
        },
        data(){
            return {
                search: '',
                results: [],
                index: -1,
                toSearch: false,
                showResults: false,
            }
        },
        watch: {
            search(val){
                
                // if(!this.toSearch || val.length < 3) return false;
                if(!this.toSearch) return false;

                switch(this.type){
                    case 'users':
                        this.searchUsers(val);
                        break;
                    case 'people':
                        this.searchPeople(val);
                        break;
                    case 'people_structures':
                        this.searchPepleOrStructures(val);
                        break;
                    case 'structures':
                        this.searchStructures(val);
                        break;
                }
                
            },
            value(val){
                this.search = val.name;
            }
        },
        methods: {
            delayClear(){
                setTimeout(this.clear, 500);
            },
            searchUsers(val){
                autocompleteRepository.searchUsers(val)
                .then(results => this.results = results)
                .catch(error => toastr.error('Ocurrio un error al buscar en usuarios'));
            },
            searchPeople(val){
                autocompleteRepository.searchPeople(this.theClientId, val)
                .then(results => this.results = results)
                .catch(error => toastr.error('Ocurrio un error al buscar en personas'));
            },
            searchPepleOrStructures(val){
                autocompleteRepository.searchPeopleOrStructures(this.theClientId, val)
                .then(results => this.results = results)
                .catch(error => toastr.error('Ocurrio un error al buscar en personas o estructuras'));
            },
            searchStructures(val){
                autocompleteRepository.searchStructures(this.theClientId, val)
                .then(results => this.results = results)
                .catch(error => toastr.error('Ocurrio un error al buscar en estructuras'));
            },
            setItem(index){
                const item = this.results[index];
                this.search = item.name;
                this.$emit('input', item);
                this.clear();
            },
            moveUp(){
                this.index = Math.max(0, this.index - 1);
            },
            moveDown(){
                this.index = Math.min(this.results.length - 1, this.index + 1);
            },
            enter(){
                if(this.search.length === 0 || (this.index === -1 && this.exists)) return false;



                let index = this.index === -1?this.results.findIndex(item => item.name.toLowerCase() === this.search.toLowerCase()):this.index;

                let item = index === -1?{ id: 0, name: this.search }:this.results[index];

                this.$emit('input', item);
                this.$emit('change');
                
                this.clear();
                
                this.search = item.name;
            },
            clear(){
                this.results = [];
                this.index = -1;
                this.showResults = false;
                this.toSearch = false;
            },
            startSearching(){
                this.showResults = true;
                this.toSearch = true;
            },
            initialize(){

            }
            
        },
        computed: {
            theClasses(){
                if(typeof this.classes === 'string'){
                    const classes = {};
                    classes[this.classes] = 1;
                    return classes;
                }

                if(Array.isArray(this.classes)){
                    const classes = {};
                    this.classes.map(theClass => classes[theClass] = 1);
                    return classes;
                }

                if(this.classes && typeof this.classes === 'object' && this.classes.constructor === Object){
                    return this.classes;
                }
            },
            theClientId(){
                return !!this.clientId? this.clientId: this.client.id;
            }
        },
        created(){
            this.$bus.$on(`${this.id}.reset`, () => {
                this.clear();
                this.search = '';
            });

            

            
        },
        mounted(){
            if(this.selectOnFocus){
                $(`#${this.id}`).focus(() => {
                    $(`#${this.id}`).select();
                });
            }
        },
        beforeDestroy(){
            this.$bus.$off(`${this.id}.reset`);
        }
    }
</script>
<style scoped>
    .autocomplete-results {
        z-index: 999;
        
    }
    .autocomplete-results ul {
        list-style: none;
    }
</style>
